/**
* DevExpress Dashboard (range-index-settings.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { StyleSettingsBase } from './style-settings-base';
export class RangeIndexSettings extends StyleSettingsBase {
    constructor(index) {
        super(null);
        this.index = ko.observable(-1);
        this.isBarStyle = ko.observable(false);
        this.index(index);
    }
    equals(style) {
        return (style instanceof RangeIndexSettings) && this.index() === style.index();
    }
    clone() {
        var style = new RangeIndexSettings(this.index());
        style.isBarStyle(this.isBarStyle());
        return style;
    }
}
